<template>
  <div class="lang" :class="{'lang--active': isActive}">
    <span class="lang__title" @click="toggle">
      <i :class="'flag-'+$root.state.lang"></i>
      <span v-if="$root.isMobile">{{$root.config.langs[$root.state.lang]}}</span>
      <i class="i-triangle" :class="{'i-triangle--up': isActive}"></i>
    </span>
    <div class="lang__list">
      <a href="#" target="_self" class="lang__item" @click.prevent="changeLanguage(key)" v-for="(item, key, index) in $root.langs" :key="index"><i :class="'flag-'+key"></i> {{item}}</a>
    </div>
    
  </div>
</template>


<style lang="scss">
.lang {
  position: relative;
  z-index: 100;
  @include mq('md') {
    display: inline-flex;
    position: relative;
    bottom: 0;
    left: 0;
    transform: none;
  }
  &__title {
    cursor: pointer;
    display: flex;
    align-items: center;
    SPAN {
      display: inline-flex;
      margin-left: 10px;
      color: #FFF;
    }
    .i-triangle {
      margin-left: 5px;
    }
    &:hover {
      .i-triangle--up {
        border-bottom-color: $color-link-hover;
      }
      .i-triangle {
        border-top-color: $color-link-hover;
      }
    }
  }
  &__list {
    margin-top: 10px;
    right: 0;
    flex-direction: column;
    white-space: nowrap;
    display: none;
    @include mq('md') {
      padding: 20px 16px;
      position: absolute;
      top: 100%;
      background: $color-background-overlay;
      box-shadow: 0px 6px 20px rgba(54, 54, 62, 0.16);
    }
  }
  &--active &__list {
    display: flex;
  }
  &__item {
    font-size: 16px;
    line-height: 20px;
    display: inline-flex;
    align-items: center;
    @include mq('md') {
      font-size: 12px;
    }
    &:not(:last-child) {
      margin-bottom: 14px;
      @include mq('md') {
        margin-bottom: 8px;
      }
    }
    I {
      margin-right: 10px;
      @include mq('md') {
        margin-right: 5px;
      }
    }
  }
}
</style>


<script>
export default {
  data: () => ({
    isActive: false
  }),
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
    changeLanguage(lang) {
      if(location.pathname.split('/').length == 2) {
        location.href = location.href + `/${lang}`;
        return;
      }
      location.href = location.href.replace(`/${this.$root.state.lang}`, `/${lang}`);
    }
  },
  created() {
    document.addEventListener('click', (e) => {
       if(!e.target.closest('.lang')) {
        this.isActive = false
      }
    });
  }

}
</script>